const SIGNATURE_WIDTH = 300;
const SIGNATURE_HEIGHT = 200;

export const getNormalizedSignatureDataUrl = (signaturePad) => {
	const sourceCanvas = signaturePad?.getCanvas?.();
	if (!sourceCanvas || typeof document === 'undefined') {
		return signaturePad?.toDataURL?.() || null;
	}

	const normalizedCanvas = document.createElement('canvas');
	normalizedCanvas.width = SIGNATURE_WIDTH;
	normalizedCanvas.height = SIGNATURE_HEIGHT;

	const context = normalizedCanvas.getContext('2d');
	if (!context) {
		return signaturePad.toDataURL();
	}

	context.drawImage(sourceCanvas, 0, 0, SIGNATURE_WIDTH, SIGNATURE_HEIGHT);
	return normalizedCanvas.toDataURL('image/png');
};
